import { observer } from 'mobx-react-lite';

import AddWellIcon from 'src/shared/assets/icons/add-well.svg';
import { Button } from 'src/shared/components/button';

import type { TemporaryChartRig } from '../../../presets/drilling-rigs-chart/entities';
import { useClickHandler } from '../../../shared/use-click-handler';
import { useMovableElement } from '../../../shared/use-movable-element';
import type { Viewport } from '../../../shared/viewport/viewport';

import styles from './data-items.module.scss';

interface Props {
  item: TemporaryChartRig;
  verticalViewport: Viewport;
  onWellAdd(): void;
}

export const EditingTemporaryRigRow = observer(function EditingTemporaryRigRow({
  item,
  verticalViewport,
  onWellAdd,
}: Props) {
  const ref = useMovableElement({
    item,
    verticalViewport,
  });
  const buttonRef = useMovableElement({
    item,
    verticalViewport,
  });

  const { onPointerUp, onPointerDown } = useClickHandler(onWellAdd);

  return (
    <>
      <div ref={ref} className={styles.temporaryRigRow} />

      <div ref={buttonRef} className={styles.addWellButtonWrapper}>
        <Button
          variant="primary"
          icon={<AddWellIcon className={styles.addRigIcon} />}
          iconPosition="before"
          className={styles.addWellButton}
          onPointerDown={onPointerDown}
          onPointerUp={onPointerUp}
        />
      </div>
    </>
  );
});
